var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from 'react';
import { useTimeout } from './useTimeout';
/**
 * Delay callback execution until the dependencies have not been updated in the delay period
 *
 * @param {() => void} callback Callback function to execute
 * @param {number} delay The number of milliseconds where the dependencies have remained unchanged before executing the callback function
 * @param {React.DependencyList} dependencies Array of items that, when one changes, it triggers the hook to execute
 * @example
 * const [count, setCount] = useState(0);
 * useDebounce(() => console.log('Call API endpoint'), 1000, [count]);
 *
 * return (
 *   <div>
 *     <div>{count}</div>
 *     <button onClick={() => setCount(count + 1)}>Increment</button>
 *   </div>
 * )
 */
export var useDebounce = function (callback, delay, dependencies) {
    var _a = useTimeout(callback, delay), clear = _a.clear, reset = _a.reset;
    useEffect(reset, __spreadArray(__spreadArray([], dependencies, true), [reset], false));
    useEffect(clear, []);
};
